import { render, staticRenderFns } from "./ProductCardOptions.vue?vue&type=template&id=0f6b2fb4&"
import script from "./ProductCardOptions.vue?vue&type=script&lang=js&"
export * from "./ProductCardOptions.vue?vue&type=script&lang=js&"
import style0 from "./ProductCardOptions.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports